module.exports = __webpack_public_path__ + "img/vectrexad2.348ebf37.jpg";